import { render, staticRenderFns } from "./_gameRules_en.vue?vue&type=template&id=67e66f10&lang=pug&"
import script from "./_gameRules_en.vue?vue&type=script&lang=js&"
export * from "./_gameRules_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports